import { useRef, useState } from 'react';
import { strToU8, zipSync } from 'fflate';
import { api } from '../api';

export default function BackupManager({ onRestored }: { onRestored: () => Promise<void> }) {
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const input = useRef<HTMLInputElement>(null);
  const exportBackup = async () => {
    setBusy(true); setMessage(''); setError('');
    try {
      const manifest = await api.backupManifest() as { products?: Array<{ images?: Array<{ storage_key?: string; url?: string }> }> };
      const files: Record<string, Uint8Array> = { 'backup.json': strToU8(JSON.stringify(manifest, null, 2)) };
      for (const product of manifest.products || []) for (const image of product.images || []) {
        if (!image.storage_key || !image.url) continue;
        const response = await fetch(image.url);
        if (!response.ok) throw new Error('לא ניתן להוריד אחת מתמונות הגיבוי');
        files[`images/${image.storage_key}`] = new Uint8Array(await response.arrayBuffer());
      }
      const archive = zipSync(files, { level: 0 });
      const blob = new Blob([archive as BlobPart], { type: 'application/zip' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url; link.download = `natalie-secondhand-backup-${new Date().toISOString().slice(0, 10)}.zip`; link.click();
      URL.revokeObjectURL(url); setMessage('הגיבוי המלא נוצר והורד למחשב');
    } catch (cause) { setError(cause instanceof Error ? cause.message : 'יצירת הגיבוי נכשלה'); }
    finally { setBusy(false); }
  };
  const restore = async (file: File | undefined) => {
    if (!file) return;
    if (!confirm('השחזור יחליף את כל המוצרים, הקטגוריות והתמונות הקיימים. להמשיך?')) { if (input.current) input.current.value = ''; return; }
    setBusy(true); setMessage(''); setError('');
    try { await api.restoreBackup(file); await onRestored(); setMessage('השחזור הושלם בהצלחה'); }
    catch (cause) { setError(cause instanceof Error ? cause.message : 'שחזור הגיבוי נכשל'); }
    finally { setBusy(false); if (input.current) input.current.value = ''; }
  };
  return <div className="admin-section"><div className="section-heading"><div><span className="eyebrow">הגנת מידע</span><h2>גיבוי ושחזור</h2></div></div>{error && <div className="form-error">{error}</div>}{message && <div className="form-success">{message}</div>}<div className="backup-cards"><article><div className="backup-icon">⇩</div><h3>יצירת גיבוי מלא</h3><p>הורדת קובץ ZIP הכולל מוצרים, קטגוריות, הגדרות וכל התמונות.</p><button className="primary" disabled={busy} onClick={exportBackup}>{busy ? 'מעבד...' : 'הורדת גיבוי'}</button></article><article className="warning-card"><div className="backup-icon">↻</div><h3>שחזור מגיבוי</h3><p>השחזור מחליף את נתוני החנות הקיימים. חשבונות המנהלים אינם משתנים.</p><button className="secondary" disabled={busy} onClick={() => input.current?.click()}>בחירת קובץ לשחזור</button><input ref={input} hidden type="file" accept=".zip,application/zip" onChange={(event) => restore(event.target.files?.[0])} /></article></div></div>;
}
